import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CarouselImage } from '../../../../../../../../shared/ui/src/lib/shared/elements/image-carousel/image-carousel.component';


@Component({
  selector: 'kion-preview-image',
  templateUrl: './preview-image.component.html',
  styleUrls: ['./preview-image.component.scss']
})
export class PreviewImageComponent {
  @Input() image: CarouselImage;
  @Input() selected: boolean;

  // tslint:disable-next-line:no-output-rename no-output-native
  @Output('select') selectImageEmitter: EventEmitter<void> = new EventEmitter<void>();

  selectImage(): void {
    this.selectImageEmitter.emit();
  }
}
